import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaChevronDown,
  FaShare,
  FaArrowLeft,
  FaArrowRight,
  FaSpinner,
} from "react-icons/fa";
import { Modal, ModalBody } from "reactstrap";
import { getCurrentUserId } from "../..//utils/auth";
import "../../css/User/AllRevolution.css";
import api from "../../api/axios";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import { toast } from "react-toastify";
import PDF from "../../assets/images/pdf/pdf.png";
import { Icon } from "@iconify/react";
import DigitalSignature from "../../components/ui/DigitalSignature/DigitalSignature";

function AllRevolution() {
  const currentUserId = getCurrentUserId();
  const sidebarMenus = getSidebarMenus(currentUserId);
  const [isRevolution, setIsRevolution] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showMediaModal, setShowMediaModal] = useState(false);
  const [activeMedia, setActiveMedia] = useState([]);
  const [mediaType, setMediaType] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeSidebar, setActiveSidebar] = useState("revolution-all");
  const [feedType, setFeedType] = useState("revolution");
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [signatureSubmitted, setSignatureSubmitted] = useState(false);
  const [signatureData, setSignatureData] = useState(null);
  const [commentInput, setCommentInput] = useState("");
  const [submitting, setSubmitting] = useState(null);
  const [supportStatus, setSupportStatus] = useState({});

  //   fetch revolution data

  const handleRevolution = async () => {
    console.log("Fetching revolutions...");
    try {
      const response = await api.get("revolution/all");
      setIsRevolution(response.data.revolutions || []);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("Something went wrong");
    }
  };

  useEffect(() => {
    handleRevolution();
  }, []);

  /* ================= HELPERS ================= */

  const toggleCard = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      // localStorage.clear();
      navigate("/login");
    }
  };

  const getMediaType = (file) => {
    const url = file.toLowerCase();
    if (url.includes(".mp4")) return "video";
    if (url.includes(".pdf")) return "pdf";

    // if (file.endsWith(".mp4")) return "video";
    // if (file.endsWith(".pdf")) return "pdf";
    return "image";
  };

  const groupMedia = (item) => {
    const { images = [], videos = [], pdfs = [] } = item;
    const preview = [];

    if (images.length > 0) {
      preview.push({
        file: images[0],
        type: "image",
        count: images.length,
      });
    }
    if (videos.length > 0) {
      preview.push({
        file: videos[0],
        type: "video",
        count: videos.length,
      });
    }
    if (pdfs.length > 0) {
      preview.push({
        file: pdfs[0],
        type: "pdf",
        count: pdfs.length,
      });
    }

    return preview;
  };

  const handleMediaClick = (item, clickedFile) => {
    const type = getMediaType(clickedFile);

    let filtered = [];
    if (type === "image") filtered = item.images || [];
    else if (type === "video") filtered = item.videos || [];
    else if (type === "pdf") filtered = item.pdfs || [];

    const startIndex = filtered.indexOf(clickedFile);

    setMediaType(type);
    setActiveMedia(filtered);
    // setCurrentIndex(startIndex);
    setCurrentIndex(startIndex >= 0 ? startIndex : 0);
    setShowMediaModal(true);
  };

  const prevMedia = () => {
    setCurrentIndex((prev) => (prev === 0 ? activeMedia.length - 1 : prev - 1));
  };

  const nextMedia = () => {
    setCurrentIndex((prev) => (prev === activeMedia.length - 1 ? 0 : prev + 1));
  };

  const [isActive, setIsActive] = useState(false);

  const RevertBack = async () => {
    setIsActive((prev) => !prev);
  };

  const ClickHrer = () => {
    setIsActive(false);
  };

  const [isRevolutionSignature, setIsRevolutionSignature] = useState(false);

  const handleAcceptRevolution = () => {
    setIsRevolutionSignature((prev) => !prev);
    setActiveMedia(false);
  };

  const SubmitSupport = async (action = "support", revolutionId) => {
    if (action === "support" && !signatureData) {
      toast.error("Please add signature.");
      return;
    }

    try {
      setSubmitting(true);

      let formData = new FormData();
      const actionType = action === "support" ? "support" : "reject";

      if (action === "support") {
        const response = await fetch(signatureData);
        const blob = await response.blob();

        formData.append("comment", commentInput);
        formData.append("digitalSignature", blob, "signature.png");
      }

      const res = await api.post(
        `/revolution/${revolutionId}/${actionType}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      setOpenId(null);
      setIsActive(false);

      const updatedAction =
        res?.data?.userAction ||
        (action === "support" ? "SUPPORTED" : "REJECTED");

      setIsRevolution((prev) =>
        prev.map((revolution) =>
          revolution._id === revolutionId
            ? {
                ...revolution,
                userAction: updatedAction,
                
                supporter: res?.data?.supporter ?? revolution.supporter, // ✅ correct
              }
            : revolution
        )
      );

      setSupportStatus((prev) => ({
        ...prev,
        [revolutionId]: updatedAction,
      }));
      toast.success(res?.data?.message || "Revolution supported successfully.");
    } catch (err) {
      const errorMsg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Failed to submit. Please try again.";
      toast.error(errorMsg);

      setSupportStatus((prev) => ({
        ...prev,
        [revolutionId]: null,
      }));
    } finally {
      setSubmitting(false);
      setCommentInput("");
      setSignatureSubmitted(false);
      setSignatureData(null);
    }
  };

  useEffect(() => {
    console.log(isActive, isRevolutionSignature, "check now ");
  });

  // external share

  const [sharePost, setSharePost] = useState(null);

  const handleExternalShare = async (post) => {
    try {
      const type = post?.feedType || "REVOLUTION";

      const shareUrl =
        type === "REVOLUTION"
          ? `${window.location.origin}/r/${post._id}`
          : `${window.location.origin}/post/${post._id}`;

      if (navigator.share) {
        await navigator.share({
          title: "Check this post",
          url: shareUrl,
        });
      } else {
        await navigator.clipboard.writeText(shareUrl);
        toast.success("Link copied to clipboard");
      }

      setSharePost(null);
    } catch (error) {
      console.log("Share failed:", error);
    }
  };

  return (
    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />
        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {!showSidebar && (
              <div
                className="left-sidebar-overlay d-md-none"
                onClick={() => setShowSidebar(true)}
              />
            )}

            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => {
                setActiveSidebar(item.key);
                if (item.path) {
                  navigate(item.path);
                }
              }}
              onLogout={handleLogout}
            />

            {/* ================= CENTER AREA ================= */}

            <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
              <div className="center-area">
                <div className="w-100 pb-5">
                  <div className="All-Revolation">
                    <div className="approval-wrapper">
                      {isLoading ? (
                        <h6 className="text-secondary text-center">
                          Loading......
                        </h6>
                      ) : isRevolution.length === 0 ? (
                        <h6 className="text-secondary text-center">
                          No Revolutions......
                        </h6>
                      ) : (
                        isRevolution.map((item) => {
                          // console.log("ITEM:", item);
                          return (
                            <div key={item._id}>
                              <div className="approval-list-card">
                                <div className="approval-list-header">
                                  <p>{item.title}</p>
                                  <FaChevronDown
                                    className={`dropdown-icon ${openId === item._id ? "rotate" : ""}`}
                                    onClick={() => toggleCard(item._id)}
                                  />
                                </div>
                                <span
                                  className={`${
                                    item.userAction === "SUPPORTED"
                                      ? "Revolution-status-color-green"
                                      : item.userAction === "REJECTED"
                                        ? "Revolution-status-color-red"
                                        : ""
                                  }`}
                                >
                                  {item.userAction === "SUPPORTED"
                                    ? "Supported"
                                    : item.userAction === "REJECTED"
                                      ? "Ignored"
                                      : ""}
                                </span>
                              </div>
                              {openId === item._id && (
                                <div className="detail-card">
                                  <div className="detail-header">
                                    <img
                                      src={`${item.from.profilePic}`}
                                      alt="profile"
                                      onError={(e) => {
                                        e.target.src =
                                          "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                                      }}
                                    />
                                    <div className="revolution_accept_reject_button">
                                      <div>
                                        <h4>
                                          {item.from.fullName}
                                          {item?.from?.adhaarVerified ===
                                            "VERIFIED" && (
                                            <Icon icon="ic:baseline-verified" />
                                          )}
                                        </h4>
                                        <small>
                                          {new Date(
                                            item.createdAt,
                                          ).toLocaleDateString()}
                                        </small>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="revolution-all-details">
                                    <div className="rev-text">
                                      <p>
                                        <strong>To:</strong> {item.to}
                                      </p>
                                      <p>
                                        <strong>Subject:</strong> {item.title}
                                      </p>
                                      <p>
                                        <strong>Description:</strong>{" "}
                                        {item.description}
                                      </p>
                                    </div>

                                    <div className="revolution-post-image">
                                      {groupMedia(item).map(
                                        (media, index, arr) => {
                                          const fileUrl = `${media.file}`;
                                          return (
                                            <div
                                              key={index}
                                              className="media-box"
                                              onClick={() =>
                                                handleMediaClick(
                                                  item,
                                                  media.file,
                                                )
                                              }
                                            >
                                              {media.type === "image" && (
                                                <div className="revolution_img">
                                                  <>
                                                    <img
                                                      src={fileUrl}
                                                      alt="media"
                                                    />
                                                    {index === 0 && (
                                                      <span className="img_length">
                                                        <p>Image's</p>
                                                        {media?.count || 0}
                                                      </span>
                                                    )}
                                                  </>
                                                </div>
                                              )}
                                              {media.type === "video" && (
                                                <div className="revolution_img">
                                                  <video
                                                    src={fileUrl}
                                                    // autoPlay
                                                    muted
                                                    controls
                                                    loop
                                                  />
                                                  {index === 1 && (
                                                    <span className="img_length">
                                                      <p>Video's</p>
                                                      {media?.count || 0}
                                                    </span>
                                                  )}
                                                </div>
                                              )}
                                              {media.type === "pdf" && (
                                                <div className="revolution_img">
                                                  <div className="pdf-preview">
                                                    <img src={PDF} alt="pdf" />
                                                  </div>
                                                  {index === 2 && (
                                                    <span className="img_length">
                                                      <p>PDF's</p>
                                                      {media?.count || 0}
                                                    </span>
                                                  )}
                                                </div>
                                              )}

                                              {media.count > 1 && (
                                                <div className="media-count-badge">
                                                  {media?.count || 0}
                                                </div>
                                              )}
                                            </div>
                                          );
                                        },
                                      )}
                                    </div>

                                    {item?.userAction === "REJECTED" && (
                                      <div className="revert_back mt-2">
                                        {!isActive && (
                                          <>
                                            <p>Support Again:</p>
                                            <span onClick={() => RevertBack()}>
                                              Click Here
                                            </span>
                                          </>
                                        )}
                                        {isActive && (
                                          <>
                                            <button
                                              className="Revert_back_support"
                                              onClick={() =>
                                                handleAcceptRevolution()
                                              }
                                            >
                                              Support
                                            </button>
                                            <button
                                              onClick={() => ClickHrer()}
                                              className="Revert_back_ignore"
                                            >
                                              Cancel
                                            </button>
                                          </>
                                        )}
                                      </div>
                                    )}

                                    {isActive && isRevolutionSignature && (
                                      <div className="signature-section">
                                        <h3 className="signature-title">
                                          Digital Signature & Comment
                                        </h3>

                                        <DigitalSignature
                                          onChange={(signature) =>
                                            setSignatureData(signature)
                                          }
                                          isSubmitted={signatureSubmitted}
                                        />

                                        <div className="comment-input-wrapper">
                                          <label className="mt-3">
                                            Add Comment
                                          </label>
                                          <textarea
                                            className="comment-input"
                                            placeholder="Write your supporting comment here..."
                                            value={commentInput}
                                            onChange={(e) =>
                                              setCommentInput(e.target.value)
                                            }
                                            disabled={submitting === item._id}
                                            rows="2"
                                          />
                                        </div>

                                        {/* ======= SUBMIT BUTTON START ======= */}

                                        <button
                                          className="btn-post-support"
                                          onClick={() =>
                                            SubmitSupport("support", item._id)
                                          }
                                          disabled={submitting}
                                        >
                                          {submitting ? (
                                            <>
                                              <FaSpinner className="spinner-icon" />
                                              Posting...
                                            </>
                                          ) : (
                                            "Submit"
                                          )}
                                        </button>

                                        {/* ======= SUBMIT BUTTON END ======= */}

                                        {item?.userAction === "REJECTED" && (
                                          <div className="Revolution_support_section">
                                            <div className="revolution_support_buttons">
                                              {/* {signatureSubmitted && (
                                                <button
                                                  onClick={() =>
                                                    SubmitSupport(
                                                      "support",
                                                      item._id,
                                                    )
                                                  }
                                                  disabled={submitting === item._id}
                                                >
                                                  {submitting === item._id ? (
                                                    <>
                                                      <FaSpinner className="spinner-icon" />
                                                      Posting...
                                                    </>
                                                  ) : (
                                                    "Submit"
                                                  )}
                                                </button>
                                              )} */}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}

                                    <div className="detail-footer">
                                      <div className="approval-count">
                                        <span className="theme-color me-1">
                                          {item.supporterCount || 0}
                                        </span>
                                        Supported
                                      </div>
                                      <div className="share-icon">
                                        <FaShare
                                          onClick={() =>
                                            handleExternalShare(item)
                                          }
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal
          isOpen={showMediaModal}
          toggle={() => setShowMediaModal(false)}
          size="lg"
          centered
          className="media-modal"
        >
          <ModalBody className="media-slider-body">
          {/* LEFT ARROW */}
          <button className="slider-btn left" onClick={prevMedia}>
            <FaArrowLeft />
          </button>

          {/* MEDIA CONTENT */}
          <div className="media-content-wrapper">
            {mediaType === "image" && (
              <img
                src={`${activeMedia[currentIndex]}`}
                className="media-full"
                alt="img"
              />
            )}

            {mediaType === "video" && (
              <video
                src={`${activeMedia[currentIndex]}`}
                controls
                muted
                autoPlay
                className="media-full"
              />
            )}

            {mediaType === "pdf" && (
              <iframe
                src={`https://docs.google.com/gview?url=${encodeURIComponent(
                  activeMedia[currentIndex]
                )}&embedded=true`}
                className="media-full"
                title="pdf"
              />
            )}
          </div>

          {/* RIGHT ARROW */}
          <button className="slider-btn right" onClick={nextMedia}>
            <FaArrowRight />
          </button>
        </ModalBody>
        </Modal>
      </div>
    </div>
  );
}

export default AllRevolution;
